import { useParams } from 'react-router';
import { ICall } from '@/types';
import { getUrl } from '@/utils/api';

function useCall(id?: string, options: any = {}) {
  const { callId } = useParams();
  const query = getUrl(`v1/calls/${id ? id : callId}`, options);
  return {
    ...query,
    data: query.data as ICall,
  };
}

export default useCall;
